<template>
  <div class="add-message" :style="{height: clientHeight}">
    <div class="add-box">
      <el-form :model="ruleForm" size="mini" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="短信类型" prop="smsType">
          <el-input  class="inputWidth"  v-model="ruleForm.smsType" disabled></el-input>
        </el-form-item>
        <el-form-item label="推送时间" prop="sendDate" >
          <el-input class="inputWidth" v-model="ruleForm.sendDate" disabled></el-input>
        </el-form-item>
        <el-form-item label="短信内容" prop="content">
          <el-input 
            class="inputWidth"
            type="textarea"
            rows="4" 
            v-model="ruleForm.content" 
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item label="接收手机号" prop="phone">
          <el-input class="inputWidth" v-model="ruleForm.phone" disabled ></el-input>
        </el-form-item>
        <!-- <el-button type="primary" @click="checkPhone">查看手机号</el-button> -->
      </el-form>
    </div>
    <check-phone :isCheckPhone.sync="isCheckPhone" :phone="phone"/>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin'
import pagePathMixin from '@/utils/page-path-mixin'
import checkPhone from './cheack-phone'
export default {
  mixins: [tableMixin,pagePathMixin],
  components: {
    checkPhone
  },
  computed: {
    ruleForm() {
      return this.$route.query
    }
  },
  data() {
    return {
      clientHeight: '86vh',
      isCheckPhone: false,
      phone: ''
    }
  },
  methods: {
    checkPhone() {
      this.$api.dataReport.decodePhone({phoneRsa:this.ruleForm.phoneRsa})
        .then(res => {
          this.phone = res.data
          this.isCheckPhone = true
        })
    }
  },
  created () {
    this.clientHeight = document.documentElement.clientHeight  - 110 + 'px'
  }
}
</script>

<style lang="stylus" scoped>
  .add-message{
    height: 89vh;
    border-radius 5px
    padding 15px 20px
    margin 5px 15px 0
    background: #fff;
    overflow: auto;
    .add-box {
      // width: 50%;
      .inputWidth {
        width: 50%;
      }
      .font-size {
        font-size: 12px;
        color: #FF6B31;
      }
    }
    .header-left-box {
      display: flex;
      align-items: center;
      width: 20%
      span {
        width: 80px;
      }
    }
    .footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .detail {
      justify-content: flex-end;
    }
  }
</style>